module.exports = __webpack_public_path__ + "static/media/update-info-cancel.bb9e54de.svg";